import { useNavigate } from "react-router-dom";
import { ChangeEvent, SyntheticEvent, useMemo, useState } from "react";
import { SearchParamsType } from "../../Masters/insuranceMasters/InsurancePlan/Types";
import { clinicId } from "../../constants";
import {  UserListType } from "./types";
import { useMutation, useQuery } from "react-query";
import usePopup from "../../hooks/usePopup";
import { getAllUser, updateStatusService } from "./service";
import debounce from "../../utilis/methods/networkHandling";
import moduleRoutes from "../../routes/moduleRouteList";
import SettingsRouteList from "../routeList";
import { Autocomplete, Button, Checkbox, CircularProgress, Divider, IconButton, Paper, Switch, Table, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import CustomTableBody from "../../utilis/component/CustomTableBody";
import { Edit } from "@mui/icons-material";

const base = (window as any)._env_?.BASE_URL;
function UserList() {
    const pageTitle = "User";
    const navigate = useNavigate();
    const [changedStatus, setChangedStatus] = useState<number>(2);
    const [searchParams, setSearchParams] = useState<SearchParamsType>({
        pageNumber: 0,
        pageSize: 25,
        filter: {
            searchText: "",
            status: changedStatus,
        },
        sortField: "",
        sortOrder: "",
        clinicId: clinicId
    });

    const [open, setOpen] = useState<boolean>(false);
    const { CustomModal, showSnackbar } = usePopup();

    const [selected, setSelected] = useState<{
        [key: number]: UserListType;
    }>({});
    const [selectedId, setSelectedId] = useState<number | null>(null)
    const {
        data: tableData,
        isLoading: tableDataLoading,
        refetch,
    } = useQuery(
        ["", searchParams],
        async () => getAllUser(searchParams),
        {
            refetchOnWindowFocus: false,
        }
    );

    const { mutate: updateStatus, isLoading } = useMutation(updateStatusService, {
        onSuccess: (result) => {
            if (result.responseIndicator == "success") {
                refetch();
                setSelected({});
                setSelectedId(null)
                setOpen(false);
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "success",
                    duration: 3000,
                });
            } else {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "warning",
                    duration: 3000,
                });
            }
        },
        onError: (e: any) => {
            showSnackbar({
                message: e?.response?.data?.responseMessage || "Something went wrong !",
                open: true,
                variant: "error",
                duration: 3000,
            });
        },
    });

    const handleChangePage = (
        _: React.MouseEvent<HTMLButtonElement> | null,
        pageNumber: number
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            pageNumber,
        }));
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            page: 0,
            pageSize: parseInt(event.target.value, 10),
        }));
    };

    const handleStatusChange = (
        _: SyntheticEvent,
        value: { label: string; value: number } | null
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            filter: {
                ...prev.filter,
                status: value ? value.value : 3,
            }
        }));
    };

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchParams((prev) => ({
            ...prev,
            filter:{
                ...prev.filter,
                searchText: e.target.value
            }
        }));
    };

    const debounceSearch = debounce(handleSearchChange, 500);

    const handleNavigateClick = (data?: UserListType) => {
        navigate(
            `${base}${moduleRoutes.mainRoute}/${moduleRoutes.settings}/${SettingsRouteList.userList}/${SettingsRouteList.addOrEdit}`,
            { state: { data: data || null } }
        );
    };

    const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const objs: { [key: number]: UserListType } = {};
            tableData?.response?.items?.map(
                (item: UserListType, index: number) => {
                    objs[index] = item;
                }
            );
            setSelected(objs);
        } else {
            setSelected({});
        }
    };

    const handleSelect = (
        isChecked: boolean,
        item: UserListType,
        index: number
    ) => {
        if (isChecked) {
            setSelected((prev) => ({
                ...prev,
                [index]: item,
            }));
        } else {
            setSelected((prev) => {
                const newSelected = { ...prev };
                delete newSelected[index];
                return newSelected;
            });
        }
    };
    const handleOpenChangeStatus = () => {
        setOpen(true);
    };

    const handleCloseChangeStatus = () => {
        setOpen(false);
    };

    const handleUpdateStatus = () => {
        
        if (changedStatus == 2) {
            showSnackbar({
                message: "Please select a status !",
                open: true,
                variant: "warning",
                duration: 3000,
            });
        } else {
            const items: {id:number,clinicId:number,status:number}[] = [];
            for (let key in selected) {
                selected[key].status = changedStatus;

                items.push({
                    id: selected[key].id,
                    clinicId: selected[key].clinicId,
                    status: changedStatus,
                });
            }
            updateStatus(items);
        }
    };

    const handleUpdateOneStatus = (
        status: boolean,
        data: UserListType
    ) => {
        setSelected({})
        setSelectedId(data.empId);
        updateStatus([
            {
                    id: data.id,
                    clinicId: data.clinicId,
                    status: status? 1 : 0
                }
        ]);
    };

    const selectedSize = useMemo(() => {
        return Object.keys(selected).length;
    }, [selected]);

    return (
        <div className="p-3">
            <CustomModal
                open={open || (isLoading && Boolean(selectedSize>0))}
                setOpen={setOpen}
                title={`Change status`}
                handleClose={handleCloseChangeStatus}
            >
                <div className="w-[50vw]">
                    <div className="max-h-[65vh] overflow-y-auto">
                        {Object.entries(selected).map(([key,item], index) => (
                            <div
                                key={`${index + key}`}
                                className="flex gap-2 ps-3 justify-start items-center py-2 overflow-y-auto"
                            >
                                <div className="h-[7px] w-[7px] bg-green-600 rounded m-2"></div>{" "}
                                <div>{`${item.username}${" - "}${item.userGroupName}`}</div>
                            </div>
                        ))}
                    </div>
                    <Divider />
                    <div className="flex justify-end items-center gap-2 p-3">
                        <Autocomplete
                            disableClearable
                            sx={{ width: "200px" }}
                            options={status}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
                            renderInput={(params) => <TextField {...params} label="Status" />}
                            onChange={(_, value) => {
                                console.log(value);
                                
                                setChangedStatus(value?.value);
                            }}
                        />
                        <Button
                            disabled={isLoading}
                            endIcon={
                                isLoading && <CircularProgress size={20} color="success" />
                            }
                            color="success"
                            onClick={handleUpdateStatus}
                        >
                            Update
                        </Button>
                    </div>
                </div>
            </CustomModal>
            <Paper>
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                            {pageTitle} Master
                        </Typography>
                    </div>
                    <div className="flex gap-2">
                        <Button
                            onClick={() => {
                                handleNavigateClick();
                            }}
                        >
                            new {pageTitle}
                        </Button>
                    </div>
                </div>
                <Divider />
                <div className="">
                    <div className="grid grid-cols-4 gap-3 py-3 px-2">
                        <Autocomplete
                            disableClearable
                            fullWidth
                            defaultValue={
                                selectedStatus[
                                searchParams.filter.status as keyof typeof selectedStatus
                                ]
                            }
                            options={statusOptions}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                            }
                            renderInput={(params) => <TextField {...params} label="Status" />}
                            onChange={handleStatusChange}
                        />
                        <TextField label={"Search"} onChange={debounceSearch} />
                    </div>
                    <TableContainer className="border">
                        {Boolean(selectedSize) && (
                            <div className="p-2">
                                <strong>Selected items {selectedSize}</strong>{" "}
                                <Button onClick={handleOpenChangeStatus}>Change Status</Button>
                            </div>
                        )}
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Checkbox
                                            checked={
                                                selectedSize == tableData?.response?.items?.length && tableData?.response?.items?.length > 0
                                            }
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    {headings.map((heading) => (
                                        <TableCell key={heading} className="font-bold">
                                            {heading}
                                        </TableCell>
                                    ))}
                                    <TableCell className="font-bold">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <CustomTableBody
                                alert={"No data"}
                                dataLoading={tableDataLoading}
                                isData={Boolean(tableData?.response?.items?.length)}
                                totalSpan={{
                                    row: searchParams.pageSize,
                                    col: headings.length + 2,
                                }}
                            >
                                {tableData?.response?.items?.map((tableItem, index) => (
                                    <TableRow key={`${pageTitle}-${index}`}>
                                        <TableCell>
                                            <Checkbox
                                                checked={Boolean(selected[index])}
                                                onChange={(e) => {
                                                    handleSelect(e.target.checked, tableItem, index);
                                                }}
                                            />
                                        </TableCell>
                                         <TableCell>{tableItem?.username}   </TableCell>
                                         <TableCell> {tableItem?.empName}  </TableCell>
                                         <TableCell> {tableItem?.userGroupName}  </TableCell>
                                         <TableCell>
                                            <span
                                              className={`font-bold ${
                                                tableItem?.status ? "text-green-600" : "text-red-600"
                                              }`}
                                            >
                                              {tableItem?.status ? "Active" : "InActive"}
                                            </span>
                                          </TableCell>
                                        <TableCell>
                                            <div className="flex gap-2">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        handleNavigateClick(tableItem);
                                                    }}
                                                >
                                                    <Edit/>
                                                </IconButton>
                                                <Switch
                                                    checked={Boolean(tableItem.status)}
                                                    disabled={isLoading && tableItem?.empId == selectedId}
                                                    onChange={(e) => {
                                                        handleUpdateOneStatus(e.target.checked, tableItem);
                                                    }}
                                                    />
                                                    {(isLoading && tableItem?.empId == selectedId) && <span className="mt-2"><CircularProgress size={18} /></span>}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </CustomTableBody>
                        </Table>
                        <div className="flex justify-end">
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component={"div"}
                                count={tableData?.response?.totalCount || 0}
                                rowsPerPage={searchParams.pageSize}
                                page={searchParams.pageNumber}
                                sx={{ border: 0 }}
                                slotProps={{
                                    select: {
                                        inputProps: {
                                            "aria-label": "rows per page",
                                        },
                                        native: true,
                                    },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            // ActionsComponent={TablePaginationActions}
                            />
                        </div>
                    </TableContainer>
                </div>
            </Paper>
        </div>
    );
}
export default UserList;

const statusOptions = [
    { label: "All", value: 2 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
];
const status = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
];
const selectedStatus = {
    2: { label: "All", value: 2 },
    1: { label: "Active", value: 1 },
    0: { label: "Inactive", value: 0 },
};

const headings = [
    "UserName",
    "Employee Name",
    "User Group",
    "status",
]